import omit from 'lodash/omit';
import { dobToDraft } from '../fields/DateOfBirth/DateOfBirth.meta';
import { DraftAccountDTO, ESigned, FormValues, IsPoliticallyExposed } from '../AccountOpening.meta';

export const formToDraft = (
  values: FormValues,
  draftAccount: DraftAccountDTO,
): DraftAccountDTO => ({
  ...draftAccount,
  ...values,

  primaryApplicant: {
    ...draftAccount.primaryApplicant,
    ...values.primaryApplicant,
    dob: values.primaryApplicant.dob ? dobToDraft(values.primaryApplicant.dob) : null,
  },

  secondApplicant: {
    ...draftAccount.secondApplicant,
    ...values.secondApplicant,
    dob: values.secondApplicant.dob ? dobToDraft(values.secondApplicant.dob) : null,
  },

  retirementAccountBeneficiaryInfo: values.retirementAccountBeneficiaryInfo.hasBeneficiary
    ? {
        ...omit(values.retirementAccountBeneficiaryInfo, 'hasBeneficiary'),
        dateOfBirth: dobToDraft(values.retirementAccountBeneficiaryInfo.dateOfBirth),
      }
    : null,

  companySymbols: values.companySymbols ? [values.companySymbols] : [],
  snapIds: values.isAffiliatedExchangeOrFINRA && values.snapId ? [values.snapId] : [],

  isPoliticallyExposed: values.isPoliticallyExposed
    ? IsPoliticallyExposed.Yes
    : IsPoliticallyExposed.No,

  trustedContactInfo: values.trustedContactInfo.hasTrustedContact
    ? { ...omit(values.trustedContactInfo, 'hasTrustedContact'), country: 'USA' }
    : null,

  interestedPartyInfo: values.interestedPartyInfo.hasInterestedParty
    ? { ...omit(values.interestedPartyInfo, 'hasInterestedParty'), country: 'USA' }
    : null,

  eSigned: values.eSigned !== null ? (values.eSigned ? ESigned.Yes : ESigned.No) : null,
});
